import React from 'react';
import './App.css';
import AppRouter from './Router.jsx';

function App() {
  return <AppRouter />;
}

export default App;
